export function buildAddressPredictionsUrl(address: string): string {
  const params = new URLSearchParams({ address });

  return `/geolocation/address-predict?${params.toString()}`;
}
